import { useCallback } from "react";
import { State, To } from "history";
import { useNavigate, useSearchParams } from "react-router-dom";

import { makePath } from "utils/url";

export const TARGET_FRONTEND_SEARCH_PARAM = "targetFrontend";

// The frontends the identity picker can redirect to once an identity is picked. It need not be an exhaustive list of
// all frontends.
// This used to be a `TargetFrontend` GraphQL enum, but no endpoint takes it any more: it is now purely a search param
// the console passes between its own screens, so this list is the source of truth.
export const TARGET_FRONTENDS = [
  "COPILOT_WEB_APP",
  "COPILOT_CHROME_EXTENSION",
  "COPILOT_MOBILE_APP",
] as const;

export type TargetFrontend = typeof TARGET_FRONTENDS[number];

export const useNavigatePreservingTargetParams = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  return useCallback(
    (
      to: To,
      options?: {
        replace?: boolean;
        state?: State;
      },
    ) => {
      const targetFrontend = params.get(TARGET_FRONTEND_SEARCH_PARAM);
      const updatedTo = makePath(to, {
        ...(targetFrontend ? { targetFrontend } : {}),
      });
      navigate(updatedTo, options);
    },
    [navigate, params],
  );
};
